import type { BuildingRoomsSections } from "../../../types/buildings-sections/rooms";

export const roomsSection: BuildingRoomsSections = {
  title: "Rooms & Spaces",
  description: "Rooms and spaces information",
  noRoomsAvailable: "No rooms available",
  addRoom: "Add room",
  editRoom: "Edit room",
  deleteRoom: "Delete room",
  noRoomsData: "No rooms data",
  roomName: "Room name",
  floorNumber: "Floor",
  height: "Height (m)",
  floor: "Floor",
  roomNumber: "Room number",
  roomType: "Room type",
  area: "Area",
  status: "Status",
  price: "Price",
  // New spaces-related translations
  spaces: "Spaces",
  addSpace: "Add space",
  spaceName: "Space name",
  spaceNumber: "Space number",
  tenant: "Tenant",
  addTenant: "Add tenant",
  noSpaces: "No spaces available",
  noRoomsInSpace: "No rooms in this space",
  useType: "Use type",
  commercial: "Commercial",
  residential: "Residential",
  tenantName: "Tenant name",
  tenantContact: "Contact person",
  tenantEmail: "Email",
  tenantPhone: "Phone",
  tenantNotes: "Notes",
  createTenant: "Create tenant",
  cancel: "Cancel",
  save: "Save",
  selectTenant: "Select tenant",
  noTenant: "No tenant",
};
